<script>
import OuterCasing from '$common/components/outer-casing';
import ComponentOuterCasing from '$common/components/component-outer-casing';
import LoadingComponents from '../loading-components';
import WechatJssdk from '$common/utils/wechat/web-jssdk';

export default {
  props: {
    indexStyle: {
      type: String,
      default: () => ''
    }
  },
	documentTitle: window?.ssrConfig?.routerConfig?.cmsData?.data?.data?.pageName ?? 'WOWNOW',
	components: { OuterCasing, ComponentOuterCasing, LoadingComponents },
	data() {
    return {
      // wechatAppid: window?.ssrConfig?.routerConfig?.appid ?? '',
			goAppRouter: (window?.ssrConfig?.routerConfig?.routePath ?? '')
    };
  },
	computed: {
		downLoad() {
      return window?.ssrConfig?.routerConfig?.downLoad ?? {};
    },
		isDingTalk: () => navigator.userAgent.toLowerCase().indexOf('dingtalk') !== -1,
    isIOS: () => navigator.userAgent.toLocaleLowerCase().indexOf('mac os x') !== -1,
    isQQ: () => navigator.userAgent.toLowerCase().indexOf('qq/') !== -1,
    isAndroid: () => navigator.userAgent.toLocaleLowerCase().indexOf('android') !== -1,
    isWechat: () => navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
	},
  created() {
    WechatJssdk.config()?.then(res => WechatJssdk?.share())?.catch(err => {
      console.log('WechatJssdk err: ', err);
    });
  },
	methods: {
		checkMasking(callback) {
      this.isShowMasking = !!(this.isWechat || this.isDingTalk || this.isQQ);
      console.log(this.isShowMasking)
      typeof callback === "function" && callback(!this.isShowMasking);
    },
		// launchError(res) {
    //   console.log('launch error')
    //   console.log(res)
    //   if (this.isIOS) {
    //     this.appleClick();
    //     return;
    //   }
    //   this.androidClick();
    // },
		appleClick() {
      this.checkMasking(isOpenClick => {
        if (this.isIOS && isOpenClick) {
          const appleLint = this.downLoad?.apple ?? '';
          // window.location.href = appleLint || 'itms-apps://itunes.apple.com/app/id1507128993';
          window.location.href = appleLint || 'itms-appss://itunes.apple.com/app/id1507128993';
        }
      });
    },
		androidClick() {
      this.checkMasking(isOpenClick => {
        if (this.isAndroid && isOpenClick) {
          this.isAndroidBtn = true;
        }
      });
    }
	}
};
</script>

<template>
	<OuterCasing>
		{{ /* 组合一些全局的组件，比如 loading、notify */ }}
    <LoadingComponents />
		<ComponentOuterCasing :style="indexStyle">
			<slot />
		</ComponentOuterCasing>
		<!-- <WxOpenLaunchApp
      :extinfoProps="goAppRouter"
      v-if="wechatAppid && $root.isWechat"
      :appid="wechatAppid"
      @click="onWxOpenLaunchAppClick"
      :clientWidth="$root.clientWidth"
      :clientHeight="$root.clientHeight"
      @launch-error="launchError"
    /> -->
	</OuterCasing>
</template>